import React, { useState, useEffect } from 'react';
import { parametriaApi } from '../../../services/api/parametriaApi';
import { FaClipboardList, FaTimes, FaSave, FaSpinner } from 'react-icons/fa';

const ParametriaPlanillaModal = ({ show, handleClose, data, onSuccess }) => {
    const isEdit = !!data;
    const [formData, setFormData] = useState({
        codigo: '',
        descripcion: '',
        valor: 0,
        activo: 1
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (show) {
            setError(null);
            if (isEdit) {
                setFormData({
                    codigo: data.codigo || '',
                    descripcion: data.descripcion || '',
                    valor: data.valor || 0,
                    activo: data.activo !== undefined ? data.activo : 1
                });
            } else {
                setFormData({
                    codigo: '',
                    descripcion: '',
                    valor: 0,
                    activo: 1
                });
            }
        }
    }, [show, data, isEdit]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData({
            ...formData,
            [name]: name === 'activo' ? Number(value) : (type === 'number' ? parseFloat(value) : value)
        });
        if (error) setError(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            if (isEdit) {
                await parametriaApi.updateParametriaPlanilla(data.id, formData);
            } else {
                await parametriaApi.createParametriaPlanilla(formData);
            }
            onSuccess(isEdit ? 'actualizado' : 'creado');
            handleClose();
        } catch (err) {
            setError(err.response?.data?.detail || 'Error al guardar parámetro');
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Inter', sans-serif"
        }}>
            <div style={{
                background: '#fff', borderRadius: 16, width: '92%', maxWidth: 520,
                boxShadow: '0 20px 60px rgba(0,0,0,0.25)'
            }}>
                <div style={{
                    background: 'linear-gradient(135deg, #667eea, #764ba2)',
                    borderRadius: '16px 16px 0 0', padding: '18px 24px',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                }}>
                    <h5 style={{ color: '#fff', margin: 0, fontWeight: 700, fontSize: 18 }}>
                        <FaClipboardList style={{ marginRight: 8 }} />
                        {isEdit ? 'Editar Parámetro' : 'Nuevo Parámetro'}
                    </h5>
                    <FaTimes onClick={handleClose} style={{ color: '#fff', cursor: 'pointer', fontSize: 18 }} />
                </div>
                <form onSubmit={handleSubmit} style={{ padding: '24px' }}>
                    {error && (
                        <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '10px 14px', marginBottom: 16, color: '#dc2626', fontSize: 14 }}>
                            {error}
                        </div>
                    )}
                    <div style={{ marginBottom: 14 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
                            Código <span style={{ color: '#ef4444' }}>*</span>
                        </label>
                        <input type="text" name="codigo" value={formData.codigo} onChange={handleChange} required maxLength={50}
                            style={{ width: '100%', padding: '8px 12px', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', border: '1.5px solid #d1d5db', outline: 'none', fontFamily: "'Inter', sans-serif" }} />
                    </div>
                    <div style={{ marginBottom: 14 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
                            Descripción <span style={{ color: '#ef4444' }}>*</span>
                        </label>
                        <textarea rows={3} name="descripcion" value={formData.descripcion} onChange={handleChange} required maxLength={255}
                            style={{ width: '100%', padding: '8px 12px', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', border: '1.5px solid #d1d5db', outline: 'none', fontFamily: "'Inter', sans-serif" }} />
                    </div>
                    <div style={{ marginBottom: 14 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
                            Valor <span style={{ color: '#ef4444' }}>*</span>
                        </label>
                        <input type="number" step="0.01" name="valor" value={formData.valor} onChange={handleChange} required
                            style={{ width: '100%', padding: '8px 12px', borderRadius: 8, fontSize: 14, boxSizing: 'border-box', border: '1.5px solid #d1d5db', outline: 'none', fontFamily: "'Inter', sans-serif" }} />
                    </div>
                    <div style={{ marginBottom: 14 }}>
                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
                            Activo
                        </label>
                        <select name="activo" value={formData.activo} onChange={handleChange}
                            style={{ width: '100%', padding: '8px 12px', borderRadius: 8, fontSize: 14, border: '1.5px solid #d1d5db', background: '#fff', outline: 'none', boxSizing: 'border-box', fontFamily: "'Inter', sans-serif" }}>
                            <option value={1}>Sí</option>
                            <option value={0}>No</option>
                        </select>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 16, paddingTop: 16, borderTop: '1px solid #e5e7eb' }}>
                        <button type="button" onClick={handleClose}
                            style={{ padding: '10px 22px', borderRadius: 8, border: '1.5px solid #d1d5db', background: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: 14, fontFamily: "'Inter', sans-serif" }}>
                            Cancelar
                        </button>
                        <button type="submit" disabled={loading}
                            style={{ padding: '10px 22px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', gap: 8, opacity: loading ? 0.8 : 1, fontFamily: "'Inter', sans-serif" }}>
                            {loading ? <FaSpinner className="fa-spin" /> : <FaSave />} {loading ? 'Guardando...' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ParametriaPlanillaModal;
